module.exports = function() {
  return new Worker(__webpack_public_path__ + "3953150bc7a93bf02d9d.worker.js");
};